export const getGoogleMapsUrlForCoordinates = (coordinates) => {
  const url = new URL(
    'https://www.google.com/maps/dir/?api=1&travelmode=walking'
  )
  url.searchParams.set('destination', `${coordinates[1]},${coordinates[0]}`)
  return url
}
